import React from "react";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { APP_SHELL_LAYOUT } from "../../../constants/constants";

export default function ClaimFixedAction({
  children,
  maxWidth = 600,
  testId,
  sx,
}) {
  if (!children) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: `calc(${APP_SHELL_LAYOUT.BOTTOM_NAV_OFFSET_CSS} + 12px)`,
        zIndex: 1200,
        display: "flex",
        justifyContent: "center",
        px: { xs: 2, sm: 3 },
        pointerEvents: "none",
      }}
    >
      <Box
        data-testid={testId}
        sx={(theme) => ({
          width: "100%",
          maxWidth,
          p: 1,
          borderRadius: 2,
          pointerEvents: "auto",
          bgcolor: alpha(theme.palette.background.paper, theme.palette.mode === "dark" ? 0.92 : 0.96),
          border: `1px solid ${alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.18 : 0.1)}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? `0 -14px 38px ${alpha(theme.palette.common.black, 0.36)}`
              : "0 -14px 34px rgba(15,23,42,0.14)",
          backdropFilter: "blur(12px)",
          ...sx,
        })}
      >
        {children}
      </Box>
    </Box>
  );
}
